export const ACTIVE_CANONICAL_PROMISE_STATUSES = [
  "ACTIVE",
  "PENDING_VERIFICATION",
  "MANUAL_REVIEW_REQUIRED",
] as const;

const ACTIVE_CANONICAL_PROMISE_STATUS_SET = new Set<string>(ACTIVE_CANONICAL_PROMISE_STATUSES);
const ACTIVE_PRESENTATION_PROMISE_STATUS_SET = new Set([
  "Open",
  "Pending",
  "Due Today",
  "Overdue",
  "Escalated",
]);

export type WorkbenchPromiseStatusRecord = {
  status?: unknown;
  canonicalStatus?: unknown;
};

export function isActiveWorkbenchPromise(promise: WorkbenchPromiseStatusRecord) {
  const canonicalStatus = String(promise.canonicalStatus || "").trim().toUpperCase();
  if (canonicalStatus) return ACTIVE_CANONICAL_PROMISE_STATUS_SET.has(canonicalStatus);
  return ACTIVE_PRESENTATION_PROMISE_STATUS_SET.has(String(promise.status || "").trim());
}

export function summarizeWorkbenchPromises(promises: WorkbenchPromiseStatusRecord[]) {
  return {
    active: promises.filter(isActiveWorkbenchPromise).length,
    total: promises.length,
  };
}
